module.exports = __webpack_public_path__ + "static/media/Bandwagon Effect - james-wainscoat-b7MZ6iGIoSI-unsplash.e6fe49b2.jpg";